<template>
    <NuxtLink class="group" :to="formattedSeoUrl(look.url)">
        <ShopwareImg
            :src="look.cover.media.url"
            :alt="look.translated.name"
            class="look-overview-image h-full w-full max-w-full object-cover"
            id="look-overview-image"
            :width="400"
            sizes="100vw sm:50vw md:400px" />

        <div class="absolute bottom-6 left-1/2 w-full -translate-x-1/2 px-1.5 text-white lg:bottom-[90px]">
            <p
                v-if="look.translated.name"
                class="font-monument-extended text-sm duration-300 group-hover:text-green-600 lg:text-lg">
                {{ look.translated.name }}
            </p>
            <button
                class="border-b-2 pt-1.5 text-center font-mori text-sm duration-300 hover:border-green-600 hover:text-green-600 group-hover:border-green-600 group-hover:text-green-600 lg:pt-4">
                {{ snippets['headless.looks.viewLook'] }}
            </button>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
    const props = defineProps({
        look: {
            type: Object,
            required: true,
        },
    });

    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;

    const formattedSeoUrl = (url: string) => {
        if (!url) return '';
        const segments = url.split('/');
        return `/nl/look/${segments[segments.length - 1]}`;
    };
</script>
